module.exports = __webpack_public_path__ + "static/media/04_waterscapes-kelowna.80010579.jpg";